// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__xEOTP","choiceBoxes":"toolbarselects_choiceBoxes__1m3HV","simpleField":"toolbarselects_simpleField__1nwjL"};